// components
import Alerts from 'components/Alerts'
import Navbar from 'components/Navbars/AuthNavbar.js'
import FooterSmall from 'components/Footers/FooterSmall.js'
import { useAuth } from 'context/authContext'

export default function Auth({ children }) {
	const { messages } = useAuth()
	return (
		<>
			<Navbar transparent />
			<div className='relative z-50'>
				<div className='absolute w-1/2 top-0 right-0 m-4'>
					{Object.keys(messages).length !== 0 && <Alerts {...messages} />}
				</div>
			</div>
			<main>
				<section
					className='flex flex-col justify-between w-full h-screen py-40 min-h-screen bg-slate-800 bg-no-repeat bg-full'
					style={{
						backgroundImage: "url('/img/register_bg_2.png')",
					}}
				>
					{children}
					<FooterSmall />
				</section>
			</main>
		</>
	)
}
